module.exports = __webpack_public_path__ + "img/08 - Condominio_das_Americas_Quadra.dc70c51b.jpg";